import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import { AirportService } from '../airport.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { AirportComment } from '../models/airport-comment.model';
import { RemarkService } from '../service/remark.service';
var AdminAirportComponent = /** @class */ (function () {
    function AdminAirportComponent(dialogRef, data, _airportService, _businessService, _snackBar, _remarkService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this._airportService = _airportService;
        this._businessService = _businessService;
        this._snackBar = _snackBar;
        this._remarkService = _remarkService;
        this.model = {};
        this.adminDeleteConfirmationArray = [];
        this.airportNotesToDelete = [];
        this.airport = data.airport;
        for (var i = 0; i < this.airport.admins.length; i++) {
            this.adminDeleteConfirmationArray.push(false);
        }
    }
    AdminAirportComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.notesArray) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this._remarkService.getRemarks(this.airport.airportId)];
                    case 1:
                        _a.notesArray = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.setNotesDataSource();
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminAirportComponent.prototype.onAddNote = function (noteForm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var remark, addedNote, _a, e_1, error;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        remark = {
                            id: null,
                            airportId: this.airport.airportId,
                            sourceId: 3,
                            commentType: AirportComment.parseCommentType('Admin'),
                            commentRef: 'Notes',
                            text: noteForm.value.note
                        };
                        return [4 /*yield*/, this._remarkService.postRemark(this.airport.airportId, remark)];
                    case 1:
                        addedNote = _b.sent();
                        if (!addedNote) return [3 /*break*/, 3];
                        noteForm.controls['note'].setValue('');
                        noteForm.form.markAsPristine();
                        noteForm.form.markAsUntouched();
                        _a = this;
                        return [4 /*yield*/, this._remarkService.getRemarks(this.airport.airportId)];
                    case 2:
                        _a.notesArray = _b.sent();
                        this.setNotesDataSource();
                        return [3 /*break*/, 4];
                    case 3:
                        this._snackBar.open('Add airport admin note failed: ' + addedNote, 'Close', {
                            duration: 5000
                        });
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        error = e_1;
                        this._snackBar.open('Add airport admin note failed: ' + error.message, 'Close', {
                            duration: 5000
                        });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AdminAirportComponent.prototype.onSaveNote = function (modifiedNote) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var remark, updatedNote, _a, e_2, error;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        remark = {
                            id: modifiedNote.id,
                            airportId: this.airport.airportId,
                            sourceId: 3,
                            commentType: AirportComment.parseCommentType('Admin'),
                            commentRef: 'Notes',
                            text: modifiedNote.text
                        };
                        return [4 /*yield*/, this._remarkService.putRemark(this.airport.airportId, remark)];
                    case 1:
                        updatedNote = _b.sent();
                        if (!updatedNote) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this._remarkService.getRemarks(this.airport.airportId)];
                    case 2:
                        _a.notesArray = _b.sent();
                        this.setNotesDataSource();
                        return [3 /*break*/, 4];
                    case 3:
                        this._snackBar.open('Updating airport admin note failed: ' + updatedNote, 'Close', {
                            duration: 5000
                        });
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_2 = _b.sent();
                        error = e_2;
                        this._snackBar.open('Updating airpot admin note failed: ' + error.message, 'Close', {
                            duration: 5000
                        });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AdminAirportComponent.prototype.onDeleteNote = function (noteToDelete) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.airportNotesToDelete.push(noteToDelete);
                return [2 /*return*/];
            });
        });
    };
    AdminAirportComponent.prototype.deleteNote = function (confirmation, note) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deletedNote, _a, index;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!confirmation) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._remarkService.deleteRemark(this.airport.airportId, note.id)];
                    case 1:
                        deletedNote = _b.sent();
                        if (!deletedNote) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, this._remarkService.getRemarks(this.airport.airportId)];
                    case 2:
                        _a.notesArray = _b.sent();
                        this.setNotesDataSource();
                        _b.label = 3;
                    case 3:
                        index = this.airportNotesToDelete.indexOf(note, 0);
                        this.airportNotesToDelete.splice(index, 1);
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminAirportComponent.prototype.applyFilter = function (filterValue) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    };
    AdminAirportComponent.prototype.shouldDisplayDeleteButtons = function (notesForDeletion, note) {
        return notesForDeletion && notesForDeletion.length > 0 &&
            notesForDeletion.findIndex(function (n) { return n.id === note.id; }) !== -1;
    };
    AdminAirportComponent.prototype.onKeyUp = function () {
        this.model.recid = this.model.recid.replace(/\D/g, '');
    };
    AdminAirportComponent.prototype.setNotesDataSource = function () {
        this.dataSource = new MatTableDataSource(this.notesArray);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    };
    AdminAirportComponent.prototype.onAddAdmin = function (addForm) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var added, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this._businessService.addAirportManager(this.airport, this.model.recid)];
                    case 1:
                        added = _b.sent();
                        if (!(added && added === 'SUCCESS')) return [3 /*break*/, 3];
                        this.model.recid = '';
                        addForm.form.markAsPristine();
                        addForm.form.markAsUntouched();
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.identifier, true)];
                    case 2:
                        _a.airport = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this._snackBar.open('Add Admin Failed: ' + added, 'Close', {
                            duration: 5000
                        });
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AdminAirportComponent.prototype.onDeleteAdmin = function (index) {
        if (this.adminDeleteConfirmationArray[index]) {
            this.adminDeleteConfirmationArray[index] = false;
            return;
        }
        this.adminDeleteConfirmationArray[index] = true;
    };
    AdminAirportComponent.prototype.onDeleteConfirm = function (recid, index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var deleted, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this._businessService.deleteAirportManager(this.airport, recid)];
                    case 1:
                        deleted = _b.sent();
                        if (!(deleted && deleted === 'SUCCESS')) return [3 /*break*/, 3];
                        this.adminDeleteConfirmationArray[index] = false;
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.identifier, true)];
                    case 2:
                        _a.airport = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this._snackBar.open('Delete Admin Failed: ' + deleted, 'Close', {
                            duration: 5000
                        });
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return AdminAirportComponent;
}());
export { AdminAirportComponent };
